import moment from "moment";
import React from "react";
import CountdownCustom from "component/component/count_down";
import { useDialogLeave } from "hook/draft/dialog/action/useDialogLeave";
import { useSelector } from "react-redux";
import { draftDialogDetailSelector } from "store/bailiff/task/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DetailCountDown = () => {
  // -------------------------- VAR -----------------------------
  const { handleLeave } = useDialogLeave();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(draftDialogDetailSelector);
  const timeOutAt = detail?.timeOutAt;
  const mTimeOutat = moment(timeOutAt?.toDate()).valueOf();
  // -------------------------- FUNCTION ------------------------
  const onCompleted = () => {
    console.log("trigger oncomplete");
    if (!detail) return;
    return handleLeave(
      "Hết thời gian làm nhiệm vụ, số điểm bạn đã chỉnh sửa sẽ không được tính",
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div
      style={{
        minHeight: 70,
        borderRadius: 5,
        border: "0.5px solid rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
      }}
    >
      <CountdownCustom date={mTimeOutat} onComplete={onCompleted} />
    </div>
  );
};
export default DetailCountDown;
